<template>
  <el-dialog title='交叉过驳' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='300px'>
    <div class='crossBarge'>
      <batch-import class='ml10' :uploadUrl='uploadUrl' :is-button='true' />
      <el-button type='primary' size='mini' class='ml10' @click='download'>模板下载</el-button>
    </div>
  </el-dialog>

</template>

<script>
  import batchImport from '@/components/batchImport';

  export default {
    name: 'index',
    components: { batchImport },
    data() {
      return {
        dialogVisible: false,
        uploadUrl: '/platform/maintain/crossBargeBatch',
      };
    },
    methods: {
      //模板下载
      download() {
        window.location.href = '/file/交叉过驳导入模板.xlsx';
      },
      dialogOpen() {
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang='scss' scoped>
  .crossBarge {
    display: flex;
    padding: 10px;
    justify-content: space-evenly;
  }
</style>
